import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Button, Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { Link2 } from "lucide-react";
import React, { useState } from "react";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import AddCommunicationDialog from "./AddCommunicationDialog.jsx";

const columns = [
  {
    field: "comm_date",
    headerName: "Date",
    type: "date",
    flex: 1,
    maxWidth: 100,
  },
  {
    field: "comm_type",
    headerName: "Communication Type",
    flex: 1,
    maxWidth: 160,
  },
  {
    field: "comm_title",
    headerName: "Title",
    flex: 1,
  },
  {
    field: "message",
    headerName: "Message",
    flex: 3,
    minWidth: 250,
    renderCell: (params) => (
      <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {params.value}
      </div>
    ),
  },
  {
    field: "link",
    sortable: false,
    minWidth: 120,
    headerName: "Document Link",
    renderCell: (params) => {
      if (params.value) {
        return (
          <a
            href={params.value}
            target="__blank"
            className="w-full h-full flex justify-center items-center"
          >
            <Link2 className="text-primary" />
          </a>
        );
      } else {
        return <Typography className="mx-auto">N/A</Typography>;
      }
    },
  },
];

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ margin: "0px", display: "flex", justifyContent: "end" }}
    >
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const CommunicationDataGrid = ({ data, schoolName }) => {
  const [open, setOpen] = useState(false);
  const [communicationTypes, setCommunicationTypes] = useState();
  const { user } = useAuth();

  const handleOpen = () => {
    getCommunitationTypes();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getCommunitationTypes = async () => {
    try {
      const res = await axiosInstance.post("/getCommType", {
        auth_token: user.auth_token,
      });
      setCommunicationTypes(res.data.data.comm_types);
    } catch (err) {
      alert(err.message);
    }
  };
  return (
    <div className="mt-3 p-2 shadow">
      <div className="flex p-3 justify-between">
        <span className="font-bold">Communication Details</span>
        <div>
          {user.user_type === "admin" && (
            <Button
              size="small"
              variant="outlined"
              startIcon={<AddOutlinedIcon />}
              onClick={handleOpen}
            >
              Add
            </Button>
          )}
        </div>
      </div>
      {data && (
        <DataGrid
          columns={columns}
          rows={data}
          getRowId={(row) => row.id}
          autoHeight={true}
          pagination
          getRowHeight={(params) => {
            const padding = 16; // Extra padding to add to the row height
            const lineHeight = 10; // Approximate line height in pixels
            const minHeight = 52; // Default row height
            const lineCount = Math.ceil(params.model.message.length / 40);
            const height = lineCount * lineHeight + padding;
            return Math.max(minHeight, height);
          }}
          pageSize={5}
          rowsPerPageOptions={[5]}
          sx={{ border: "none" }}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      )}

      <AddCommunicationDialog
        schoolName={schoolName}
        open={open}
        onClose={handleClose}
        communicationTypes={communicationTypes}
      />
    </div>
  );
};

export default CommunicationDataGrid;
